// FILE: src/pages/ClientPortal/ClientAttendance.jsx
import React, { useEffect, useState, useCallback } from 'react';
import { clientPortalAPI } from '../../api/services';
import { toast } from 'react-toastify';
import './ClientPortal.css';

const fmtDate = (d) => d ? new Date(d).toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric'}) : '—';
const fmtTime = (d) => d ? new Date(d).toLocaleTimeString('en-US',{hour:'2-digit',minute:'2-digit'}) : null;

export default function ClientAttendance() {
  const [records, setRecords] = useState([]);
  const [today,   setToday]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [clock,   setClock]   = useState(new Date());

  useEffect(() => { const t = setInterval(() => setClock(new Date()), 1000); return () => clearInterval(t); }, []);

  const load = useCallback(async () => {
    try {
      const [allRes, todayRes] = await Promise.all([
        clientPortalAPI.getAttendance(),
        clientPortalAPI.getTodayAttendance(),
      ]);
      setRecords(allRes.data.data || []);
      setToday(todayRes.data.data || []);
    } catch { toast.error('Failed to load attendance.'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  function elapsed(from) {
    if (!from) return '—';
    const diff = Math.floor((clock - new Date(from)) / 1000);
    const h = Math.floor(diff/3600), m = Math.floor((diff%3600)/60);
    return `${h}h ${m}m`;
  }

  return (
    <div className="cp-page">
      <div className="cp-header">
        <h1 className="cp-title">Caregiver Activity</h1>
        <p className="cp-subtitle">Clock-in and clock-out records for your care visits</p>
      </div>

      {/* Today Live */}
      {today.length > 0 && (
        <div className="cp-section">
          <div className="cp-section-title">⚡ Today's Activity (Live)</div>
          {today.map((r, i) => (
            <div key={i} className="cp-attendance-row" style={{ borderLeft:'4px solid #059669' }}>
              <div>
                <div style={{ fontWeight:700, color:'#111827' }}>{r.CaregiverName}</div>
                <div style={{ fontSize:13, color:'#6b7280' }}>{fmtDate(r.Date)}</div>
              </div>
              <div style={{ textAlign:'center' }}>
                <div className="cp-time-in">IN: {fmtTime(r.ClockInTime) || '—'}</div>
                {r.ClockOutTime
                  ? <div className="cp-time-out">OUT: {fmtTime(r.ClockOutTime)}</div>
                  : <div className="cp-time-live">🟢 Live: {elapsed(r.ClockInTime)}</div>
                }
              </div>
              <div style={{ textAlign:'right' }}>
                {r.HoursWorked
                  ? <div className="cp-hours">{r.HoursWorked}h worked</div>
                  : r.ClockInTime && !r.ClockOutTime
                  ? <div className="cp-hours" style={{color:'#d97706'}}>In progress</div>
                  : null
                }
              </div>
            </div>
          ))}
        </div>
      )}

      {/* All History */}
      <div className="cp-section">
        <div className="cp-section-title">📋 Visit History</div>
        {loading ? <p style={{color:'#6b7280'}}>Loading…</p>
         : records.length === 0
         ? <div className="cp-empty"><div className="cp-empty-icon">⏱️</div><div className="cp-empty-text">No attendance records yet</div></div>
         : records.map((r, i) => (
            <div key={i} className="cp-attendance-row">
              <div>
                <div style={{ fontWeight:700, color:'#111827' }}>{r.CaregiverName}</div>
                <div style={{ fontSize:13, color:'#6b7280' }}>{fmtDate(r.Date)}</div>
              </div>
              <div style={{ textAlign:'center' }}>
                <div className="cp-time-in">IN: {fmtTime(r.ClockInTime) || '—'}</div>
                {r.ClockOutTime
                  ? <div className="cp-time-out">OUT: {fmtTime(r.ClockOutTime)}</div>
                  : <div className="cp-time-live">🟢 Still active</div>
                }
              </div>
              <div className="cp-hours">{r.HoursWorked ? `${r.HoursWorked}h` : '—'}</div>
            </div>
          ))
        }
      </div>
    </div>
  );
}
